<template>
    <div class="menuList">
        <div class="descktopMediaBox">
            <div class="menuBanner">
                <img :src="getStaticImage('landingpage-min.jpg')">
            </div>
            <div class="container">
                <div class="menuTitle">
                    <div class="h1 text-center">{{ settings.title }}</div>
                    <div class="breadCr">
                        <router-link :to="{name: 'Home'}">Home</router-link> <span>/</span>
                        <div><router-link :to="{name:'Menu'}">Menu</router-link></div> <span>/</span>
                        <div>{{ settings.title }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row" v-if="menuItems && menuItems.length">
                <div
                    class="menuEl"
                    v-for=" (val, index) in menuItems"
                    :class="{'col-12': !index, 'col-6' : index}"
                    @click="$router.push({name: 'SingleMenuItem', params: {id: val.menu_id, business_id: bId}})"
                >
                    <div class="frame" v-if="val.photo_large" :style="{backgroundImage: `url(${val.photo_large})`}"></div>
                    <div class="frame" v-else :style="{backgroundImage: `url(${getStaticImage('def_img.jpg')})`}"></div>
                    <div class="title h4">
                        {{ val.menu_title }}
                    </div>
                    <div class="price caption">
                        <div class="price" v-if="val.menu_price">
                            ${{ showPrice(val) }}
                        </div>
                        <div class="nutritcal" v-if="val.nutritional_facts">
                            / {{ val.nutritional_facts.total_calories }} cal
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-12">
                    <h4>Sorry nothing found</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuList",
        props: ["menuItems"],
        data() {
            return {
                showList: true
            }
        },
        created() {
            /*console.log(this.menuItems && this.menuItems.length);
            console.log(this.menuItems);*/
        },
        methods: {
          showPrice(item){
              if (item.menu_price === "0.00"){
                  this.$store.dispatch("menu/getMenuItem", {
                      itemId: item.menu_id,
                      justReturn: true,
                      callback: (data)=>{
                          item.menu_price = data.modifiers[0]?.options[0]?.cost ?? item.menu_price
                      }
                  })
              }
              return item.menu_price
          }
        },
        computed:{
            settings() {
                return this.$store.state.shared.topBar;
            },
            bId(){
                return this.$store.state.shared.businessId;
            }
        }
    }
</script>
